import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import PrivacyPolicyComponent from '@ui/components/Privacy-policy/Privacy-policy.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    privacyPolicyAccepted,
    privacyPolicyError,
    email,
    password,
    passwordConfirm,
    emailError,
    passwordError,
    passwordConfirmError,
    serverError,
    registerError,
    onEmailChange,
    onPasswordChange,
    onPasswordConfirmChange,
    onPrivacyPolicyClick,
    onSignUpClick,
    onInputClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (registerError) return 'registerError';
        else if (serverError) return 'serverError';
        else if (privacyPolicyError) return 'privacyPolicyError';
        else return '';
    }, [registerError, serverError, privacyPolicyError]);

    return (
        <ModalComponent
            className="register"
            title="registration"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="email"
                    name="email"
                    type="email"
                    helperText="emailAlertMessage"
                    errorMessage="emailAlertMessage"
                    lang={lang}
                    value={email}
                    error={emailError}
                    onChange={onEmailChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="password"
                    name="password"
                    type="password"
                    helperText="passwordAlertMessage"
                    errorMessage="passwordAlertMessage"
                    lang={lang}
                    value={password}
                    error={passwordError}
                    onChange={onPasswordChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="passwordConfirm"
                    name="password-confirm"
                    type="password"
                    errorMessage="passwordConfirmAlertMessage"
                    lang={lang}
                    value={passwordConfirm}
                    error={passwordConfirmError}
                    onChange={onPasswordConfirmChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <PrivacyPolicyComponent
                    accepted={privacyPolicyAccepted}
                    lang={lang}
                    onClick={onPrivacyPolicyClick}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="signUp"
                    lang={lang}
                    onClick={onSignUpClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const RegisterComponent = React.memo(Component);

export default RegisterComponent;
